import { createReducer, on } from '@ngrx/store';

import { NotificationFeedActions } from './notification-feed-state.actions';
import {
  initialNotificationFeedState,
  notificationFeedAdapter,
  NotificationFeedStateModel,
} from './notification-feed-state.model';

export const notificationFeedStateReducer = createReducer<NotificationFeedStateModel>(
  initialNotificationFeedState,
  on(
    NotificationFeedActions.getUserNotificationsSuccess,
    NotificationFeedActions.initSuccess,
    (state, { resp }): NotificationFeedStateModel =>
      notificationFeedAdapter.setAll(resp?.notifications ?? [], {
        ...state,
        currentPage: 1,
        hasMore: resp?.hasMore ?? false,
      })
  ),
  on(NotificationFeedActions.loadMoreNotificationsSuccess, (state, { resp }): NotificationFeedStateModel =>
    notificationFeedAdapter.addMany(resp?.notifications ?? [], {
      ...state,
      currentPage: state.currentPage + 1,
      hasMore: resp?.hasMore ?? false,
    })
  ),
  on(NotificationFeedActions.markNotificationsAsRead, (state, { ids }): NotificationFeedStateModel =>
    notificationFeedAdapter.updateMany(
      ids.map(id => ({ id, changes: { markedReadAt: new Date() } })),
      state
    )
  ),
  on(NotificationFeedActions.markNotificationAsUnread, (state, { id }): NotificationFeedStateModel =>
    notificationFeedAdapter.updateOne({ id, changes: { markedReadAt: undefined } }, state)
  ),
  on(NotificationFeedActions.markAllAsRead, (state): NotificationFeedStateModel => {
    const markedReadAt = new Date();
    const updates = (state.ids as number[]).map(id => ({ id, changes: { markedReadAt } }));
    return notificationFeedAdapter.updateMany(updates, state);
  }),
  on(NotificationFeedActions.openItemDetail, (state, { notification }): NotificationFeedStateModel =>
    notification.markedReadAt
      ? state
      : notificationFeedAdapter.updateOne({ id: notification.id, changes: { markedReadAt: new Date() } }, state)
  ),
  on(NotificationFeedActions.setFilterOption, (state, { filterBy }): NotificationFeedStateModel =>
    notificationFeedAdapter.removeAll({
      ...state,
      filterBy,
      currentPage: 1,
      hasMore: true,
    })
  ),
  on(NotificationFeedActions.refreshFeed, (state): NotificationFeedStateModel => ({
    ...state,
    currentPage: 1,
    hasMore: true,
  }))
);
